import type { SpinnerProps } from '@zillow/constellation';
import { Spinner } from '@zillow/constellation';

import { StyledSpinnerContainer } from './StyledComponents';

type SpinnerContainerProps = {
  size?: (typeof SpinnerProps)['size'];
  height?: string;
  padding?: string | number;
};

const SpinnerContainer = ({ size = 'sm', height = '200px', padding = 8 }: SpinnerContainerProps) => (
  <StyledSpinnerContainer height={height} padding={padding} data-testid="spinnerContainer">
    <Spinner size={size} />
  </StyledSpinnerContainer>
);

export default SpinnerContainer;
